var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "block", padding: "0 8px" } },
    [
      _c("el-button", {
        attrs: {
          type: "warning",
          circle: "",
          icon: "el-icon-plus",
          disabled: _vm.loading,
        },
        on: {
          click: function ($event) {
            _vm.dialogVisible = true
          },
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: { top: "20vh", title: "新增合約", visible: _vm.dialogVisible },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleDialogClose,
          },
        },
        [
          _c(
            "el-card",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogLoading,
                  expression: "dialogLoading",
                },
              ],
            },
            [
              _c(
                "el-form",
                {
                  ref: "formRef",
                  staticClass: "dialog-contract",
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "column",
                    gap: "12px 0",
                  },
                  attrs: { inline: true, model: _vm.params },
                  nativeOn: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "dialog-contract-item",
                      attrs: { label: "合約名稱", prop: "name" },
                    },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "請輸入合約名稱" },
                        model: {
                          value: _vm.params.params.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.params.params,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "params.params.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "dialog-contract-item",
                      attrs: { label: "時效性", prop: "type" },
                    },
                    [
                      _c("el-switch", {
                        attrs: {
                          "active-text": "永久",
                          "active-value": 2,
                          "inactive-value": 1,
                          "inactive-text": "1小時",
                        },
                        model: {
                          value: _vm.params.params.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.params.params, "type", $$v)
                          },
                          expression: "params.params.type",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "flex-direction": "column",
                        gap: "12px 0",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "dialog-contract-item",
                          attrs: { label: "合約檔案" },
                        },
                        [
                          _c("Upload", {
                            ref: "uploadRef",
                            attrs: {
                              accept: ".pdf",
                              payload: _vm.params,
                              "data-obj": _vm.fileObj,
                              limitText: "檔案須為.pdf格式，限制不超過50MB",
                              "limit-file-count": 1,
                              "use-drag": false,
                              action: "file/fileUpload",
                              "auto-upload": false,
                              "show-file-list": true,
                              "form-on-loading-parent": _vm.dialogLoading,
                              "btn-txt": "選擇合約",
                              "before-file-list":
                                _vm.params.fileInfo &&
                                _vm.params.fileInfo.length
                                  ? _vm.params.fileInfo[0].files
                                  : [],
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticStyle: { color: "#4b4b4b" },
                  attrs: { type: "warning" },
                  on: { click: _vm.handleSubmit },
                },
                [_vm._v("儲 存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }